import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import MeetingInfo from 'page/Details/component/MeetingInfo';
import Breadcrumb from 'component/Breadcrumb';
import { useSelector, useDispatch } from 'react-redux';
import Avatar from 'component/Avatar';

import styles from './index.module.scss';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { RootState } from 'model';
import { changeAttendState, getMeetingDetails, setMeetingInfo } from 'model/meeting';
import { AttendState, Meeting, MeetingState } from 'type/meeting';
import { getStaffId } from 'data/storage';
import { Person } from 'type/contact';
import ConfirmModal from 'component/ConfirmModal';
import cooperationSDK from 'lib/cooperationSdk';
import classnames from 'classnames';
import { getPageFrom, getRedirect, RedirectPage } from 'util/meeting';
import { usePageView, useTimeOnPage } from '@cvte/react-fridayagent3';
import FRIDAYAGENT_EVENTS from 'constant/fridayAgentEvent';

interface IProp {}

const Invite: React.FC<IProp> = () => {
  const params: { id: string } = useParams();
  const staffId = getStaffId();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const meeting = useSelector((state: RootState) => state.meeting.meetingInfo) as Meeting;
  const [inviter, setInviter] = useState({} as Person);
  const [crumbItems, setCrumbItems] = useState<{ path?: string; label: string }[]>([]);

  const isDisable = !!meeting && (meeting.state >= MeetingState.SAVED || meeting.state === MeetingState.DISBAND);

  // 埋点
  usePageView(FRIDAYAGENT_EVENTS.WEB_TEAMS_PAGEVIEW_MEETING_INVITE);
  useTimeOnPage(FRIDAYAGENT_EVENTS.WEB_TEAMS_TIMEONPAGE_MEETING_INVITE);

  useEffect(() => {
    dispatch(getMeetingDetails(params.id));

    setCrumbItems([getPageFrom(), { label: '会议邀请' }]);

    return () => {
      dispatch(setMeetingInfo({} as Meeting));
    };
  }, []);

  useEffect(() => {
    if (!meeting || !meeting._id) return;

    const redirect = getRedirect(meeting, staffId);
    if (redirect.page !== RedirectPage.INVITED) {
      dispatch(setMeetingInfo({} as Meeting));
      history.replace(redirect.path + location.search);
      return;
    }

    setInviter(meeting.members[0]?.invitor || {});
  }, [meeting]);

  const chgAttenStatus = (toState: AttendState) => {
    if (isDisable) return;
    dispatch(
      changeAttendState({
        meetingId: meeting._id,
        state: toState
      })
    );
  };

  const confirm = (title: string, onOk: () => void) => {
    ConfirmModal({
      title,
      onOk
    });
  };

  const confirmRefuse = (onOk: () => void) => {
    ConfirmModal({
      title: '确定不参加该场会议吗？',
      okText: '不参加',
      cancelText: '取消',
      onOk
    });
  };

  return (
    <>
      <Breadcrumb items={crumbItems}></Breadcrumb>
      {meeting && meeting._id ? (
        <div className={classnames(styles.container, cooperationSDK.isCoEnv ? styles.co : '')}>
          <div className={styles.title}>
            <div className={styles.avatar}>
              <Avatar src={inviter.avatar} />
            </div>
            {inviter.realName}邀请你参加以下会议
          </div>
          <div className={styles.info}>
            <MeetingInfo info={meeting} />
          </div>
          {!isDisable && (
            <div className={styles.buttons}>
              <div className={styles.join}>
                <Button type="primary" block onClick={chgAttenStatus.bind(this, AttendState.JOINED)}>
                  参加会议
                </Button>
              </div>
              <div className={styles.reject}>
                <Button block onClick={() => confirmRefuse(chgAttenStatus.bind(this, AttendState.REFUSED))}>
                  拒绝
                </Button>
              </div>
              <div className={styles.reject}>
                <Button block onClick={() => confirm('你确定不参加该场会议吗？', chgAttenStatus.bind(this, AttendState.ASK_FOR_LEAVE))}>
                  请假
                </Button>
              </div>
            </div>
          )}
        </div>
      ) : null}
    </>
  );
};

export default Invite;
